import { useState, useEffect } from "react";
import ConfirmDialog from "./../common/ConfirmDialog";

export default function MarketplaceCard({
  id,
  nombre,
  bgColor,
  textColor,
  activoInicial,
  onToggle,
  disabled = false,

}) {
  const [activo, setActivo] = useState(activoInicial);
  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    setActivo(activoInicial);
  }, [activoInicial]);

  const confirmarCambio = () => {
  const nuevoEstado = activo ? 0 : 1;

  console.log("CONFIRMADO", { id, nuevoEstado }); // 👈 DEBUG

  setActivo(!activo);
  setOpenConfirm(false);

  onToggle(id, nuevoEstado);
};

  return (
    <>
      <div
        onClick={() => !disabled && setOpenConfirm(true)}
        className={`
            ${bgColor}
            p-4 rounded shadow
            flex flex-col items-center justify-center
            transition-all duration-300
            ${activo ? "opacity-100" : "opacity-40 grayscale"}
            ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
        `}
        >

        <span className={`text-lg font-bold ${textColor}`}>
          {nombre}
        </span>

        <span className="text-xs mt-2 text-white">
          {activo ? "ON" : "Off"}
        </span>
      </div>

      <ConfirmDialog
        isOpen={openConfirm}
        onClose={() => setOpenConfirm(false)}
        onConfirm={confirmarCambio}
        title="Confirmar cambio"
        description={`¿Deseas ${activo ? "desactivar" : "activar"} ${nombre}?`}
      />
    </>
  );
}
